import { Button, Label, Textarea, TextInput } from "flowbite-react";
import React, { useRef } from "react";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import Icon1 from "../../img/ico-1.png";
import Icon2 from "../../img/ico-2.png";
import Icon3 from "../../img/ico-3.png";

const MySwal = withReactContent(Swal);

const ownerEMail = 'discoverloan2u@gmail.com';
const  commonSubject = 'Message to Discover Loan';

function Hero() {
  const contactForm = useRef(null);
  // const name = useRef(null);
  // const email = useRef(null);
  // const comment = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = contactForm.current;
    const subject = `${commonSubject} from ${form['name'].value}`;
    const message = form['comment'].value.replaceAll('\n', '%0D');
    const footer = `%0D%0D${form['name'].value}%0D${form['email'].value}`;
    const emailBody = message + footer;
    window.open(`mailto:${ownerEMail}?subject=${subject}&body=${emailBody}`, '_self');

    MySwal.fire({
      icon: 'success',
      title: 'Success',
      text: 'Your Message is submitted'
    }).then(() => {
      form.reset();
    });

  }

  return (
    <section >
      <form className="text-slate-700 bg-hero-extend h-[auto] xl:h-[1000px] flex flex-col justify-center items-center space-y-[64px] py-4 p-9"
      ref={contactForm}
      onSubmit={handleSubmit}>
      <h3 className="text-xl md:text-2xl font-semibold text-white text-center px-4">
        LOOKING FORWARD FOR COOPERATION OPPORTUNITIES.
      </h3>
      <div className="card p-8 text-center lg:grid lg:grid-cols-3 lg:w-[70%] gap-4 ">
        <div className="md:col-span-2 text-left lg:pr-7">
          <h6 className="text-2xl font-semibold text-[#244565] mb-2">
            Send us a message
          </h6>
          <p>
            If you have any queries related to our services, you can send us
            message from here.
            <br />
            It's our pleasure to help you.
          </p>
          {/* form */}
          <div className="flex flex-col space-y-4 py-6">
            <div className="">
              <div className="mb-2">
                <Label htmlFor="name" value="Your Name" className="!text-lg" />
              </div>
              <TextInput
                // ref={name}
                id="name"
                type="text"
                placeholder="Enter Your name"
                required={true}
              />
            </div>
            <div className="">
              <div className="mb-2">
                <Label
                  htmlFor="email"
                  value="Your email"
                  className="!text-lg"
                  pattern="^[a-zA-Z]+(([',. -/][a-zA-Z ])?[a-zA-Z]*)*$"
                />
              </div>
              <TextInput
                // ref={email}
                id="email"
                type="email"
                placeholder="Enter Your email"
                required={true}
                pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"
              />
            </div>
            <div className="">
              <div className="mb-2 block">
                <Label htmlFor="comment" value="Your message" />
              </div>
              <Textarea
                // ref={comment}
                id="comment"
                name="comment"
                placeholder="Leave a comment..."
                required={true}
                rows={6}
              />
            </div>
            <Button
        className="!my-10 lg:hidden !bg-[#244565] min-w-[200px] hover:shadow-lg hover:-translate-x-px hover:shadow-[#244565]/50"
        type="submit"
        // onClick={handleSubmit}
      >
        Send Now
      </Button>
          </div>
        </div>
        <div className="!mt-0 bg-[#E9EEF4] flex flex-col justify-start space-y-6 px-3 py-12">
          <div className=" flex flex-col items-center justify-center space-y-1 px-3">
            <img alt="" src={Icon1} className="w-[40px] h-[40px] mb-3" />
            <h6 className="text-base">Address</h6>
            <p>
              10-02, Tropicana Gardens Office Block,
              <br />
              Persiaran Surian, 47810, Petaling Jaya,
              <br />
              Selangor.
            </p>
          </div>
          <div className=" flex flex-col items-center justify-center space-y-1 px-3">
            <img alt="" src={Icon2} className="w-[40px] h-[40px] mb-3" />
            <h6 className="text-base">Phone</h6>
            <p>
              <a
                className=""
                href="tel:+60129367303"
                target="_blank"
                rel="noreferrer"
              >
                +60 12 936 7303
              </a>              
            </p>
          </div>
          <div className=" flex flex-col items-center justify-center space-y-1 px-3">
            <img alt="" src={Icon3} className="w-[40px] h-[40px] mb-3" />
            <h6 className="text-base">Email</h6>
            <a
              className=""
              href="mailto:general.discoverloan@gmail.com"
              target="_blank"
              rel="noreferrer"
            >
              general.discoverloan@gmail.com
            </a>
          </div>
        </div>
      </div>
      <Button
        type="submit"
        className="hidden lg:flex  !bg-[#244565] min-w-[200px] mb-10 hover:shadow-lg hover:-translate-x-px hover:shadow-[#244565]/50"
        // onClick={() => alert("send!")}
      >
        Send Now
      </Button>
      </form>
    </section>
  );
}

export default Hero;
